import { render } from "./Locale.vue?vue&type=template&id=3c1bf8ff&scoped=true&ts=true"
import script from "./Locale.vue?vue&type=script&lang=ts"
export * from "./Locale.vue?vue&type=script&lang=ts"

import "./Locale.vue?vue&type=style&index=0&id=3c1bf8ff&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1bf8ff"]])

export default __exports__